<oiq-layout-header
  *ngIf="!isEmpty"
  (logout)="logout.next()"
  (searched)="searched.next($event)"
  [isImpersonated]="isImpersonated"
  [brandImg]="brandImg"
  [logoType]="logoType"
  [emailAppEnabled]="emailAppEnabled"
  [account]="account"></oiq-layout-header>

<aside class="sidebar-overlay" (click)="layout.sidebarToggle()"></aside>

<oiq-layout-sidebar
  *ngIf="!isEmpty"
  [menu]="menu"
  [settingsMenu]="settingsMenu"
  [navPath]="navPath"></oiq-layout-sidebar>

<main class="v2-content-wrapper">
  <section>
    <ng-content></ng-content>
  </section>
  <!-- This is where child routes will be rendered -->
  <router-outlet></router-outlet>
</main>
